export const FORM_ACTIONS = {
  UPDATE_PERSONAL_DETAIL: "form_actions_update_personal_detail",
  SHOW_ERROR_MESSAGE: "form_actions_show_error_message",
  STORE_VERIFY_CODE: "form_actions_store_verify_code",
  TOGGLE_VERIFY_DRAWER: "form_actions_toggle_verify_drawer"
};



// WEBPACK FOOTER //
// ./src/modules/ContactForm/actions/types.js